export enum HCPFlowEnum {
  AWAITING_ART = 'AWAITING_ART',
  SHEET = 'SHEET',
  PRODUCTION = 'PRODUCTION',
  MACHINE_PRODUCTION = 'MACHINE_PRODUCTION',
  LOGISTICS = 'LOGISTICS',
}

export interface IHCPFlowKanbanPayload {
  flow: HCPFlowEnum
  page?: number
  offset?: number
  searchBy?: string
  allArtsApproved?: boolean
}

export interface IHCPFlowPositionPayload {
  flow: HCPFlowEnum
  statusSequence: number
}

export interface IMoveHCPFlowCardPayload {
  flow: HCPFlowEnum
  statusSequence: number
  orderProductIds: Array<string | number>
}

export interface IHCPFlowSheetRule {
  familyValue?: string | null
  volumetryValue?: string | null
  masterCode?: string | null
}

export interface IHCPFlowStatus {
  id: string
  flow: string
  flowCode: number
  name: string
  sequence: number
  displayCode: string
  masterCode?: string | null
  isActive: boolean
  sheetRule?: IHCPFlowSheetRule | null
}

export interface IHCPFlowStatusInput {
  name: string
  sequence?: number
  masterCode?: string
  familyValue?: string
  volumetryValue?: string
  isActive?: boolean
}

export type {
  IHCPFlowKanbanCard,
  IHCPFlowHistory,
  IFlowManagementCardSelection,
} from './hcp-flow-card.interface'

import type { IHCPFlowKanbanCard } from './hcp-flow-card.interface'

export interface IHCPFlowKanbanColumn {
  statusId: string
  flow: string
  flowCode: number
  sequence: number
  displayCode: string
  name: string
  masterCode?: string | null
  isActive: boolean
  sheetRule?: IHCPFlowSheetRule | null
  page: number
  offset: number
  total: number
  hasNextPage: boolean
  cards: IHCPFlowKanbanCard[]
}

export interface IHCPFlowKanbanResponse {
  flow: string
  page: number
  offset: number
  columns: IHCPFlowKanbanColumn[]
  total: number
  hasNextPage: boolean
}
